import { createI18n } from "vue-i18n";
import messages from "../locale";

export const i18n = createI18n({
    locale: "mm",
    fallbackLocale: "mm",
    messages,
});

export const currentLocale = () => {
    return localStorage.getItem("locale");
};

export const getMessage = (locale = null) => {
    return i18n.global.getLocaleMessage(locale ?? currentLocale()).message;
};

export const trans = (key, locale = null) => {
    return i18n.global.getLocaleMessage(locale ?? currentLocale()).message[
        `${key}`
    ]
        ? i18n.global.getLocaleMessage(currentLocale()).message[`${key}`]
        : key;
};

export const transNum = (key) => {
    let numArr = String(key).split("");
    numArr = numArr.map((i) => getMessage()[i]);
    return numArr.join("");
};

export const message = getMessage();
export const locale = currentLocale();

export default {
    i18n,
    getMessage,
    trans,
    currentLocale,
    transNum,
    message,
    locale,
};
